package org.dronda.app.web.repository

import com.github.michaelbull.result.Result
import com.github.michaelbull.result.map
import org.dronda.api.wishlist.EventRequest
import org.dronda.api.wishlist.UpdateEventRequest
import org.dronda.api.wishlist.toApi
import org.dronda.api.wishlist.toDomain
import org.dronda.app.web.client.EventClient
import org.dronda.service.wishlist.core.domain.CreatedEvent
import org.dronda.service.wishlist.core.domain.EventAdminDetails
import org.dronda.service.wishlist.core.domain.EventDetails
import org.dronda.service.wishlist.core.domain.Exclusion
import org.dronda.service.wishlist.core.domain.SantaSendKind
import org.dronda.service.wishlist.core.domain.SantaSendResult
import org.dronda.service.wishlist.core.domain.WishlistEvent
import org.dronda.service.wishlist.core.domain.WishlistUser

class EventRepository(
    private val eventClient: EventClient
) {

    suspend fun getEvents(): Result<List<WishlistEvent>, Unit> {
        return eventClient.getEvents().map { events -> events.map { it.toDomain() } }
    }

    suspend fun getEvent(eventId: String): Result<EventDetails, Unit> {
        return eventClient.getEvent(eventId).map { it.toDomain() }
    }

    suspend fun createEvent(request: EventRequest): Result<CreatedEvent, Unit> {
        return eventClient.createEvent(request).map { it.toDomain() }
    }

    suspend fun updateEvent(eventId: String, request: UpdateEventRequest): Result<WishlistEvent, String> {
        return eventClient.updateEvent(eventId, request).map { it.toDomain() }
    }

    suspend fun addParticipant(eventId: String, email: String): Result<WishlistUser, String> {
        return eventClient.addParticipant(eventId, email).map { it.toDomain() }
    }

    suspend fun getAdminDetails(eventId: String): Result<EventAdminDetails, String> {
        return eventClient.getAdminState(eventId).map { it.toDomain() }
    }

    suspend fun updateExclusions(eventId: String, exclusions: List<Exclusion>): Result<EventAdminDetails, String> {
        return eventClient.updateExclusions(eventId, exclusions.toApi()).map { it.toDomain() }
    }

    suspend fun sendAssignments(eventId: String, kind: SantaSendKind): Result<SantaSendResult, String> {
        return eventClient.sendAssignments(eventId, kind.toApi()).map { it.toDomain() }
    }
}
